import React from 'react';
import { Form, Input, InputNumber, Select, Switch, Card } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

interface ChannelFormProps {
    form: any;
}

export const ChannelForm: React.FC<ChannelFormProps> = ({ form }) => {
    return (
        <Card title="基本信息" style={{ marginBottom: 16 }}>
            <Form form={form} layout="vertical">
                <Form.Item name="name" label="渠道名称" rules={[{ required: true }]}>
                    <Input placeholder="如：中美海运-盐田港" />
                </Form.Item>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <Form.Item name="origin_location" label="起运地" rules={[{ required: true }]}>
                        <Input placeholder="如：中国深圳" />
                    </Form.Item>

                    <Form.Item name="destination_country" label="目的地国家" rules={[{ required: true }]}>
                        <Input placeholder="如：美国" />
                    </Form.Item>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                    <Form.Item name="shipping_method" label="运输方式" rules={[{ required: true }]}>
                        <Select>
                            <Option value="sea">海运</Option>
                            <Option value="air">空运</Option>
                            <Option value="express">快递</Option>
                            <Option value="rail">铁路</Option>
                            <Option value="truck">卡车</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="transit_days" label="时效（天）" rules={[{ required: true }]}>
                        <InputNumber style={{ width: '100%' }} min={1} />
                    </Form.Item>

                    <Form.Item name="is_active" label="是否启用" valuePropName="checked" initialValue={true}>
                        <Switch />
                    </Form.Item>
                </div>

                <Form.Item name="notes" label="备注">
                    <TextArea rows={3} placeholder="服务商、特殊要求等" />
                </Form.Item>
            </Form>
        </Card>
    );
};
